import { render, staticRenderFns } from "./IconTsInput1.vue?vue&type=template&id=fed46c46&"
import script from "./IconTsInput1.vue?vue&type=script&lang=js&"
export * from "./IconTsInput1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports